/* a11y-overlay.js - additiver A11y-Layer fuer Overlays (Theme Xtra), Audit 2026-06-27 / #11
   Greift NICHT in openPanel / nav_burger / hidePanels ein. Beobachtet den Zustand und
   ergaenzt nur die echten Luecken:
     (1) Fokus-Trap (Tab / Shift+Tab bleibt im offenen Dialog)
     (2) aria-modal dynamisch (nur waehrend offen -> kein Inert-Hintergrund im geschlossenen Zustand)
     (3) Esc schliesst auch die .m6pn-Panels (Theme-Esc deckt nur Mobile-Menu + Suche)
     (4) garantierte Fokus-Rueckgabe an den Trigger (Theme macht das nur bei whatInput=keyboard; whatInput fehlt hier)
     (5) aria-expanded am Trigger synchron
   Alles defensiv (try/catch, Null-Checks) - darf die Seite niemals brechen. */
(function () {
  'use strict';
  try {
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
                    'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function visibleFocusable(container) {
      return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
        return (el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement) &&
               el.getAttribute('aria-hidden') !== 'true';
      });
    }

    // Letztes Trigger-Element merken (fuer Fokus-Rueckgabe).
    var lastTrigger = null;
    function rememberTrigger(e) {
      try {
        var t = e.target.closest && e.target.closest(
          'a[data-panel], a[aria-controls="nav"], a[aria-controls="search"], a.search-compact'
        );
        if (t) lastTrigger = t;
      } catch (x) {}
    }
    document.addEventListener('mousedown', rememberTrigger, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ') rememberTrigger(e);
    }, true);

    function makeTrap(container) {
      function onKeydown(e) {
        if (e.key !== 'Tab') return;
        var f = visibleFocusable(container);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (!container.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      container.addEventListener('keydown', onKeydown);
      return function cleanup() { container.removeEventListener('keydown', onKeydown); };
    }

    // Generischer Dialog-Binder: reagiert auf Zustandswechsel ueber den vorhandenen
    // Mechanismus (aria-hidden bzw. html-Klasse), ersetzt diesen aber nicht.
    function bindDialog(opts) {
      var el = opts.element;
      if (!el) return;
      var trapCleanup = null, wasOpen = false, contentMo = null;

      function sync(open) {
        var trg = opts.trigger ? opts.trigger() : lastTrigger;
        if (trg) { try { trg.setAttribute('aria-expanded', open ? 'true' : 'false'); } catch (x) {} }
      }
      function focusInto() {
        // Schon ein Kind fokussiert? Dann Fokus nicht klauen.
        if (el.contains(document.activeElement) && document.activeElement !== el) return;
        if (!opts.isOpen()) return;
        var f = visibleFocusable(el);
        var target = f.length ? f[0] : null;
        if (!target) { if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1'); target = el; }
        try { target.focus(); } catch (x) {}
      }
      function open() {
        if (wasOpen) return; wasOpen = true;
        try { el.setAttribute('aria-modal', 'true'); } catch (x) {}
        if (opts.role) { try { el.setAttribute('role', opts.role); } catch (x) {} }
        if (opts.labelledby) { try { el.setAttribute('aria-labelledby', opts.labelledby); } catch (x) {} }
        trapCleanup = makeTrap(el);
        sync(true);
        // Fokus in den Dialog - mehrfach, da Inhalt/Transition asynchron rendern kann
        // (Theme setzt Fokus nur bei whatInput=keyboard, was hier fehlt).
        focusInto();
        setTimeout(focusInto, 130);
        setTimeout(focusInto, 400);
        // Inhalt rendert async (Cart-Fetch / rerender) -> bei DOM-Aenderung erneut fokussieren,
        // solange der Fokus ausserhalb gelandet ist (z.B. nach innerHTML-Swap auf <body>).
        try {
          contentMo = new MutationObserver(function () { if (!el.contains(document.activeElement)) focusInto(); });
          contentMo.observe(el, { childList: true, subtree: true });
        } catch (x) {}
      }
      function close() {
        if (!wasOpen) return; wasOpen = false;
        if (trapCleanup) { trapCleanup(); trapCleanup = null; }
        if (contentMo) { try { contentMo.disconnect(); } catch (x) {} contentMo = null; }
        try { el.removeAttribute('aria-modal'); } catch (x) {}
        if (opts.role) { try { el.removeAttribute('role'); } catch (x) {} }
        if (opts.labelledby) { try { el.removeAttribute('aria-labelledby'); } catch (x) {} }
        sync(false);
        // Fokus-Rueckgabe an Trigger, falls er ins Leere / in den schliessenden Dialog gefallen ist.
        var trg = opts.trigger ? opts.trigger() : lastTrigger;
        if (trg && (document.activeElement === document.body ||
                    document.activeElement === null ||
                    el.contains(document.activeElement))) {
          try { trg.focus(); } catch (x) {}
        }
      }
      function evaluate() { opts.isOpen() ? open() : close(); }

      try {
        var mo = new MutationObserver(evaluate);
        mo.observe(opts.observeTarget || el, { attributes: true, attributeFilter: opts.attr || ['class', 'aria-hidden'] });
      } catch (x) {}
      evaluate();
    }

    function init() {
      // ---- .m6pn-Panels (Side-Cart, Quickshop) -------------------------------
      Array.prototype.forEach.call(document.querySelectorAll('.m6pn[id]'), function (panel) {
        bindDialog({
          element: panel,
          observeTarget: panel,
          attr: ['aria-hidden', 'class'],
          isOpen: function () { return panel.getAttribute('aria-hidden') === 'false'; },
          trigger: function () {
            return document.querySelector('a[data-panel="' + panel.id + '"].m6pn-clicked') ||
                   document.querySelector('a[data-panel="' + panel.id + '"]');
          }
        });
      });

      // ---- Mobile-Menu (#nav via html.m2a). aria-expanded macht das Theme schon. -
      var nav = document.getElementById('nav');
      if (nav) {
        var html = document.documentElement;
        bindDialog({
          element: nav,
          observeTarget: html,
          attr: ['class'],
          role: 'dialog',
          isOpen: function () { return html.classList.contains('m2a'); },
          trigger: function () { return document.querySelector('a[aria-controls="nav"]'); }
        });
      }

      // ---- Such-Overlay (#search via html.search-compact-active) --------------
      var search = document.getElementById('search');
      if (search) {
        var htmlS = document.documentElement;
        bindDialog({
          element: search,
          observeTarget: htmlS,
          attr: ['class'],
          role: 'dialog',
          labelledby: 'search-title',
          isOpen: function () { return htmlS.classList.contains('search-compact-active'); },
          trigger: function () { return document.querySelector('a.search-compact'); }
        });
      }

      // ---- Esc schliesst offene .m6pn-Panels (Theme-Esc deckt sie nicht) ------
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        var openPanel = document.querySelector('.m6pn[aria-hidden="false"]');
        if (openPanel && typeof window.hidePanels === 'function') {
          try { window.hidePanels(); } catch (x) {}
        }
      });

      // ---- CSS-Hover-Dropdowns (Sprache/Land): aria-expanded nicht-invasiv syncen.
      // Kein Eingriff in Sichtbarkeit (CSS :hover/:focus-within bleibt) - nur ARIA-State.
      Array.prototype.forEach.call(
        document.querySelectorAll('a.toggle[aria-haspopup]'),
        function (toggle) {
          var li = toggle.closest('li');
          if (!li) return;
          function set(v) { try { toggle.setAttribute('aria-expanded', v ? 'true' : 'false'); } catch (x) {} }
          li.addEventListener('focusin', function () { set(true); });
          li.addEventListener('focusout', function () {
            setTimeout(function () { if (!li.contains(document.activeElement)) set(false); }, 0);
          });
          li.addEventListener('mouseenter', function () { set(true); });
          li.addEventListener('mouseleave', function () { if (!li.contains(document.activeElement)) set(false); });
        }
      );
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  } catch (e) {
    if (window.console && console.warn) console.warn('[a11y-overlay] init failed:', e);
  }
})();

/* MT-GPT-A18-INFO-ANFANG
   GPT A18-003 (08.10.2026): Info-Knopf am Lieferstatus (.mt-info-btn, role="button") reagiert auch auf Enter und Leertaste.
   Escape schließt das Info-Fenster und gibt den Fokus an den Knopf zurück. aria-expanded folgt dem Fenster.
   Das Öffnen selbst bleibt beim vorhandenen Klick des Knopfs (snippets/mt-stock-badge-inhalt.liquid). */
(function () {
  'use strict';
  try {
    var fenster = function (b) { var w = b && b.closest ? b.closest('.mt-stock-wrap') : null; return w ? w.querySelector('.mt-popup') : null; };
    var offen = function (p) { return !!p && p.style.display === 'block'; };
    var abgleich = function () {
      var bs = document.querySelectorAll('.mt-info-btn');
      for (var i = 0; i < bs.length; i++) { try { bs[i].setAttribute('aria-expanded', offen(fenster(bs[i])) ? 'true' : 'false'); } catch (x) {} }
    };
    document.addEventListener('keydown', function (e) {
      var t = e.target;
      if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && t && t.classList && t.classList.contains('mt-info-btn')) {
        e.preventDefault(); t.click(); return;
      }
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var ps = document.querySelectorAll('.mt-popup'), zu = null;
      for (var i = 0; i < ps.length; i++) { if (offen(ps[i])) { ps[i].style.display = 'none'; zu = zu || ps[i]; } }
      if (!zu) return;
      var w = zu.closest('.mt-stock-wrap'), b = w ? w.querySelector('.mt-info-btn') : null, a = document.activeElement;
      if (b && (!a || a === document.body || w.contains(a))) { try { b.focus(); } catch (x) {} }
      abgleich();
    });
    document.addEventListener('click', function () { setTimeout(abgleich, 0); });
  } catch (e) {
    if (window.console && console.warn) console.warn('[a11y-overlay] Info-Knopf:', e);
  }
})();
/* MT-GPT-A18-INFO-ENDE */

/* MT-GPT-A18-GALERIE-ANFANG
   GPT A18 (08.10.2026): Vorlesenamen auf deutschen Seiten auf Deutsch. Der Slider des Themes bringt nur englische mit
   („Next slide“, „Previous slide“, „Go to slide 2“), das Vorschaubild heißt „Thumbnail“, die Schließen-Knöpfe der Fenster und
   die Klapp-Links im Fuß der Seite heißen „Close“. Englische Seiten bleiben unverändert. Geändert werden nur Namen für
   Vorleseprogramme (aria-label, alt), nichts Sichtbares. */
(function () {
  'use strict';
  try {
    if ((document.documentElement.lang || '').toLowerCase().indexOf('de') !== 0) return;
    var NAMEN = { 'Next slide': 'Nächstes Bild', 'Previous slide': 'Vorheriges Bild' };
    var MELD = { prevSlideMessage: 'Vorheriges Bild', nextSlideMessage: 'Nächstes Bild', firstSlideMessage: 'Das ist das erste Bild', lastSlideMessage: 'Das ist das letzte Bild', paginationBulletMessage: 'Zu Bild {{index}}' };
    var wartet = false;
    var lauf = function () {
      wartet = false;
      try {
        var els = document.querySelectorAll('.swiper-button-next[aria-label], .swiper-button-prev[aria-label], .swiper-pagination-bullet[aria-label]');
        for (var i = 0; i < els.length; i++) {
          var a = els[i].getAttribute('aria-label'), m = /^Go to slide (\d+)$/.exec(a || '');
          if (NAMEN[a]) els[i].setAttribute('aria-label', NAMEN[a]); else if (m) els[i].setAttribute('aria-label', 'Zu Bild ' + m[1]);
        }
        var bilder = document.querySelectorAll('.swiper-pagination-bullet img[alt="Thumbnail"]');
        for (var j = 0; j < bilder.length; j++) {
          var kachel = bilder[j].closest('.swiper-pagination-bullet');
          bilder[j].setAttribute('alt', 'Vorschaubild ' + (Array.prototype.indexOf.call(kachel.parentNode.children, kachel) + 1));
        }
        var zu = document.querySelectorAll('a.m6pn-close, a.cookie-close, a.search-compact-toggle, button.overlay-close, button.overlay-close-clipping, a.header-toggle');
        for (var q = 0; q < zu.length; q++) {
          var al = zu[q].getAttribute('aria-label');
          if (al === 'Close' || (!al && (zu[q].textContent || '').replace(/\s+/g, ' ').trim() === 'Close')) zu[q].setAttribute('aria-label', zu[q].classList.contains('header-toggle') ? 'Bereich auf- oder zuklappen' : 'Schließen');
        }
        var sw = document.querySelectorAll('.swiper, .swiper-container, .swiper-initialized');
        for (var k = 0; k < sw.length; k++) {
          var s = sw[k].swiper;
          if (s && s.params && s.params.a11y && s.params.a11y.nextSlideMessage === 'Next slide') { for (var n in MELD) s.params.a11y[n] = MELD[n]; }
        }
      } catch (x) {}
    };
    var plan = function () { if (wartet) return; wartet = true; setTimeout(lauf, 200); };
    var start = function () {
      lauf();
      try { new MutationObserver(plan).observe(document.body, { childList: true, subtree: true }); } catch (x) {}
      setTimeout(lauf, 1500); setTimeout(lauf, 4000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  } catch (e) {
    if (window.console && console.warn) console.warn('[a11y-overlay] Galerie-Namen:', e);
  }
})();
/* MT-GPT-A18-GALERIE-ENDE */
